export default __webpack_public_path__ + "components/app-store/static/s1-f1d5159bd1bb3097f0907d70539291a3.jpg";